// src/index.js
 import React from "react";
 import { createRoot } from "react-dom/client";
 import "./index.css";
 import App from "./App";
 const container = document.getElementById("root");
 // createRoot(container) replaces ReactDOM.render in React 18+
 const root = createRoot(container);
 root.render(
   <React.StrictMode>
     <App />
   </React.StrictMode>
 );